import { constants } from '../utils'
import base from './base'

const { headers, url } = base

const buildHeaders = () => ({
  Accept: 'application/json',
  Authorization: headers().Authorization,
})

const list = async (scheduleId, patientId) =>
  fetch(`${url(constants.api.uploadedFiles)}?schedule_id=${scheduleId}&patient_id=${patientId}`, {
    method: 'GET',
    headers: buildHeaders(),
  })

const upload = async (files, scheduleId, patientId) => {
  const formData = new FormData()
  files.forEach(file => formData.append('files[]', file))
  formData.append('schedule_id', scheduleId)
  formData.append('patient_id', patientId)

  return fetch(url(constants.api.uploadedFiles), {
    method: 'POST',
    headers: buildHeaders(),
    body: formData,
  })
}

const remove = async id =>
  fetch(`${url(constants.api.uploadedFiles)}/${id}`, {
    method: 'DELETE',
    headers: buildHeaders(),
  })

export default { list, upload, remove }
